export type SSOAPIBaseErrorOptions = {
    cause?: Error,
    requestStartTimeMS?: number,
    requestEndTimeMS?: number,
    requestExecutionTimeMS?: number
};

export class SSOAPIBaseError extends Error {
    public cause: Error | undefined;
    public requestStartTimeMS: number | null = null;
    public requestEndTimeMS: number | null = null;
    public requestExecutionTimeMS: number | null = null;
    constructor(message?: string, options?: SSOAPIBaseErrorOptions) {
        //TODO: update to super(message, options) once we upgrade to node 18
        super(message);
        if (options?.cause) {
            this.cause = options.cause;
        }
        if (options?.requestStartTimeMS) {
            this.requestStartTimeMS = options.requestStartTimeMS;
        }
        if (options?.requestEndTimeMS) {
            this.requestEndTimeMS = options.requestEndTimeMS;
        }
        if (options?.requestExecutionTimeMS) {
            this.requestExecutionTimeMS = options.requestExecutionTimeMS;
        }
        // restore prototype chain
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
